
// npm
import React from 'react'


const AppPageContext = React.createContext();


export {AppPageContext}